//import libraries
import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute, RouterEvent, Event } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http'
import { Title } from '@angular/platform-browser';

declare var toastr: any;
declare var MINOVATE:any;

@Injectable({ providedIn: 'root' })

export class GeneralService {

	private MINOVATES = MINOVATE();

	constructor(
		private router: Router,
		private title: Title,
		private activatedRoute: ActivatedRoute,
		private http: HttpClient
	) { }

	//detect routing change
	routingChange(): void {

		this.MINOVATES = MINOVATE();

		this.router.events
			.pipe(
				map((event) => {
					
					if(event instanceof NavigationEnd)
						this.TitleChange();

					return event;
				})
			)
			.subscribe((event: Event) => {

				switch (true) {
					case event instanceof NavigationStart: {
						this.MINOVATES.pageLoader.enable();
						break;
					}
					case event instanceof NavigationEnd: {
						this.MINOVATES.pageLoader.disable();
						break;
					}
					case event instanceof NavigationCancel:
					case event instanceof NavigationError: {
						this.MINOVATES.pageLoader.disable();
						break;
					}
					default: {
						break;
					}
				}

			});
	}

	//change title of each page
	TitleChange(): void {

		let appTitle = this.title.getTitle();

		let child = this.activatedRoute.firstChild;

		while (child.firstChild) {
			child = child.firstChild;
		}
		if (child.snapshot.data['title']) {
			appTitle = child.snapshot.data['title'];
		}
		
		this.title.setTitle(appTitle);

	}

	//notification message
	notify_msg($type, $msg) {
		if ($type == 'success')
			toastr.success($msg);
		else
			toastr.error($msg);
	}

	service_inject(langData, data) {
		let lang = {};

		Object.keys(langData).forEach((key) => {
			lang[key] = (data[langData[key]]) ? data[langData[key]] : langData[key];
		});

		return lang;
	}

	notify_inject(langData, data) {
		let lang = {};

		Object.keys(langData).forEach((key) => {
			lang[key] = (data[langData[key]]) ? data[langData[key]] : langData[key];
		});

		return lang;
	}

	getAssets(url) {
		return this.http.get(url, { responseType: 'blob' });
	}

	cookie(type, index, data : any = {}) {

        if(type == 'set')
            localStorage.setItem(index, JSON.stringify(data));
        else if(type == 'get')
            return JSON.parse(localStorage.getItem(index));

	}
	
	

}